import React from "react";
import {Redirect, Route} from "react-router-dom";
import { isAuth } from "./guards";

const PrivateRoute = ({component: Component, ...rest}) => (
    <Route
        {...rest}
        render={props =>
            isAuth() === true ? (
                <Component {...props} />
            ) : (
                <Redirect to="/signin"/>
            )
        }
    />
);

export default PrivateRoute;
